import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=3529594a&scoped=true&"
import script from "./EmergencyContacts.vue?vue&type=script&lang=ts&"
export * from "./EmergencyContacts.vue?vue&type=script&lang=ts&"
import style0 from "./EmergencyContacts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmergencyContacts.vue?vue&type=style&index=1&id=3529594a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529594a",
  null
  
)

export default component.exports